import type { LoadProgress } from '../types';

export class LoadingScreen {
  private screen: HTMLElement;
  private bar: HTMLElement;
  private text: HTMLElement;

  constructor() {
    this.screen = document.getElementById('loading-screen')!;
    this.bar = document.getElementById('loading-bar')!;
    this.text = document.getElementById('loading-text')!;
  }

  update(progress: LoadProgress) {
    const pct = Math.round((progress.loaded / progress.total) * 100);
    this.bar.style.width = `${pct}%`;

    const phaseNames = ['', 'Loading roads & character', 'Loading buildings', 'Loading details', 'Loading forest'];
    this.text.textContent = `${phaseNames[progress.phase] || 'Loading'} — ${pct}%`;
  }

  hide() {
    this.screen.classList.add('fade-out');
    setTimeout(() => {
      this.screen.style.display = 'none';
    }, 600);
  }

  show() {
    this.screen.style.display = 'flex';
    this.screen.classList.remove('fade-out');
  }
}
